<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<a id="epig_1">
</a>
<p class="ep1">A man’s greatest strength can likewise be his greatest weakness.</p>
<p class="eps">—Origin Unknown</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KingofStorms_epig_1.vue?66131266